module.exports = __webpack_public_path__ + "static/media/gasExplore.08961690.png";